/**
 * PRG - POST Redirect GET utilities
 */
export class PrgHandler {
  constructor(selector) {
    if (!selector) {
      throw new Error('Missing required argument. new PrgHandler needs a selector reference');
    }
    this.endpointUrl = '/api/prg';
    this.prgLink = document.querySelectorAll(selector);

    this.redirect = this.redirect.bind(this);
    this.addEventListeners();
  }

  addEventListeners() {
    this.prgLink.forEach((el) => el.addEventListener('click', this.redirect));
  }

  redirect(evt) {
    const link = evt.currentTarget;

    fetch(
      this.endpointUrl,
      {
        method: 'POST',
        body: JSON.stringify({
          tx_gs1base: {
            prgData: link.getAttribute('data-prg-data')
          }
        }),
        headers: {
          'Content-Type': 'application/json',
        },
        redirect: 'manual'
      })
      .then((response) => response.json())
      .then(responseData => {
        const target = responseData.redirectUrl;
        if (target) {
          window.location.assign(target);
        }
      })
      .catch(error => {
        console.error(error); // picked up by Sentry
      });
  }
}
